var _path, _g, _path2, _path3, _path4, _g2, _g3, _rect, _rect2, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrawBgLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 568,
    height: 327,
    viewBox: "0 0 568 327",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_32215_69",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 161,
    y: 0,
    width: 250,
    height: 73
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M161 8C161 3.58172 164.582 0 169 0H286H403C407.418 0 411 3.58172 411 8V73H161V8Z",
    fill: "#014A73"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_32215_69)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161 16C161 7.16346 168.163 0 177 0H286H395C403.837 0 411 7.16344 411 16V37.35V56C411 64.8366 403.837 72 395 72H177C168.163 72 161 64.8366 161 56V37.35V16Z",
    fill: "url(#paint0_radial_32215_69)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.231 -24.9785C428.092 -32.0822 424.485 -38.9203 420.344 -45.4264L289.956 36.7634L381.334 -87.1188C375.122 -91.6997 368.509 -95.8158 361.562 -99.4672L289.889 36.7634L306.722 -116.065C302.848 -116.463 298.973 -116.795 295.099 -116.928C291.225 -117.06 287.284 -116.994 283.41 -116.861L289.889 36.7634L227.567 -103.982C220.42 -100.861 213.54 -97.1436 207.061 -92.9611L289.889 36.7634L165.379 -53.9906C160.837 -47.75 156.762 -41.1775 153.155 -34.273L289.889 36.8298L136.857 20.0998C136.523 23.6184 136.189 27.2034 136.055 30.7885C135.922 34.971 136.055 39.0871 136.189 43.1368L289.889 36.7634L149.281 98.3063C152.421 105.344 156.161 112.115 160.303 118.555L289.889 36.8298L199.312 159.65C205.524 164.164 212.07 168.214 218.95 171.733L289.956 36.8298L273.323 188.065C277.131 188.463 280.938 188.795 284.812 188.928C288.687 189.06 292.561 188.994 296.368 188.861L289.956 36.8963L351.676 176.247C358.757 173.127 365.57 169.542 372.116 165.492L290.022 36.8963L413.797 127.053C418.406 120.879 422.548 114.439 426.155 107.601L290.089 36.8298L442.988 53.4936C443.455 49.4438 443.789 45.3277 443.923 41.1452C444.056 37.5601 443.99 33.9751 443.923 30.3901L290.089 36.7634L431.298 -24.9785H431.231Z",
    fill: "#D8F1FF",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_32215_69)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 286,
    cy: 51.5,
    rx: 82,
    ry: 18.5,
    fill: "url(#paint1_linear_32215_69)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M205.367 49V27.1H209.867V44.95H218.717V49H205.367ZM227.705 49.3C225.485 49.3 223.725 48.7 222.425 47.5C221.145 46.3 220.505 44.66 220.505 42.58V27.1H225.005V42.55C225.005 43.47 225.235 44.18 225.695 44.68C226.175 45.16 226.845 45.4 227.705 45.4C228.545 45.4 229.205 45.16 229.685 44.68C230.165 44.18 230.405 43.47 230.405 42.55V27.1H234.905V42.58C234.905 44.64 234.255 46.28 232.955 47.5C231.675 48.7 229.925 49.3 227.705 49.3ZM244.734 49.3C243.274 49.3 241.994 49.03 240.894 48.49C239.794 47.93 238.934 47.16 238.314 46.18C237.714 45.18 237.414 44.02 237.414 42.7V33.4C237.414 32.06 237.714 30.9 238.314 29.92C238.934 28.94 239.794 28.18 240.894 27.64C241.994 27.08 243.274 26.8 244.734 26.8C246.214 26.8 247.494 27.08 248.574 27.64C249.674 28.18 250.524 28.94 251.124 29.92C251.744 30.9 252.054 32.06 252.054 33.4H247.554C247.554 32.52 247.304 31.85 246.804 31.39C246.324 30.93 245.634 30.7 244.734 30.7C243.834 30.7 243.134 30.93 242.634 31.39C242.154 31.85 241.914 32.52 241.914 33.4V42.7C241.914 43.56 242.154 44.23 242.634 44.71C243.134 45.17 243.834 45.4 244.734 45.4C245.634 45.4 246.324 45.17 246.804 44.71C247.304 44.23 247.554 43.56 247.554 42.7H252.054C252.054 44.02 251.744 45.18 251.124 46.18C250.524 47.16 249.674 47.93 248.574 48.49C247.494 49.03 246.214 49.3 244.734 49.3ZM254.232 49V27.1H258.732V35.68H260.832L264.492 27.1H269.352L264.792 37.45L269.532 49H264.612L260.862 39.61H258.732V49H254.232ZM275.82 49V41.2L269.52 27.1H274.23L276.99 33.7C277.27 34.36 277.51 35.06 277.71 35.8C277.93 36.54 278.08 37.14 278.16 37.6C278.26 37.14 278.4 36.54 278.58 35.8C278.78 35.06 279.01 34.36 279.27 33.7L281.94 27.1H286.62L280.32 41.2V49H275.82ZM304.537 49V27.1H311.647C313.167 27.1 314.487 27.39 315.607 27.97C316.747 28.55 317.627 29.37 318.247 30.43C318.887 31.47 319.207 32.7 319.207 34.12V41.95C319.207 43.35 318.887 44.58 318.247 45.64C317.627 46.7 316.747 47.53 315.607 48.13C314.487 48.71 313.167 49 311.647 49H304.537ZM309.037 44.95H311.647C312.547 44.95 313.277 44.67 313.837 44.11C314.417 43.55 314.707 42.83 314.707 41.95V34.12C314.707 33.24 314.417 32.53 313.837 31.99C313.277 31.43 312.547 31.15 311.647 31.15H309.037V44.95ZM321.415 49V27.1H328.435C329.995 27.1 331.345 27.37 332.485 27.91C333.625 28.45 334.505 29.22 335.125 30.22C335.765 31.22 336.085 32.4 336.085 33.76C336.085 35.18 335.735 36.45 335.035 37.57C334.355 38.69 333.425 39.5 332.245 40L336.385 49H331.495L327.955 40.72H325.855V49H321.415ZM325.855 36.82H328.435C329.435 36.82 330.205 36.57 330.745 36.07C331.305 35.57 331.585 34.87 331.585 33.97C331.585 33.03 331.305 32.3 330.745 31.78C330.205 31.26 329.435 31 328.435 31H325.855V36.82ZM336.973 49L342.343 27.1H348.043L353.473 49H348.883L347.833 44.05H342.613L341.563 49H336.973ZM343.363 40.45H347.053L346.003 35.17C345.863 34.41 345.713 33.66 345.553 32.92C345.413 32.16 345.303 31.57 345.223 31.15C345.143 31.57 345.033 32.15 344.893 32.89C344.773 33.63 344.633 34.38 344.473 35.14L343.363 40.45ZM355.352 49L353.312 27.1H356.882L357.992 41.74C358.012 42.02 358.032 42.42 358.052 42.94C358.092 43.44 358.122 43.97 358.142 44.53C358.182 45.07 358.202 45.56 358.202 46C358.242 45.56 358.282 45.07 358.322 44.53C358.382 43.97 358.432 43.44 358.472 42.94C358.532 42.42 358.572 42.02 358.592 41.74L360.332 27.1H363.752L365.432 41.74C365.472 42.02 365.512 42.42 365.552 42.94C365.612 43.44 365.672 43.97 365.732 44.53C365.792 45.07 365.842 45.56 365.882 46C365.902 45.56 365.922 45.07 365.942 44.53C365.962 43.97 365.982 43.44 366.002 42.94C366.042 42.42 366.072 42.02 366.092 41.74L367.112 27.1H370.712L368.522 49H363.842L362.372 34.45C362.352 34.11 362.312 33.67 362.252 33.13C362.212 32.57 362.172 31.99 362.132 31.39C362.092 30.79 362.052 30.26 362.012 29.8C361.992 30.26 361.962 30.79 361.922 31.39C361.882 31.99 361.842 32.57 361.802 33.13C361.762 33.67 361.722 34.11 361.682 34.45L360.062 49H355.352Z",
    fill: "#006C99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164 16C164 8.82031 169.82 3 177 3H286H395C402.18 3 408 8.8203 408 16V37.35V56C408 63.1797 402.18 69 395 69H177C169.82 69 164 63.1797 164 56V37.35V16Z",
    stroke: "#2294D3",
    strokeWidth: 6
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 101C20 96.5817 23.5817 93 28 93H540C544.418 93 548 96.5817 548 101V235H20V101Z",
    fill: "#2294D3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 257H568V319C568 323.418 564.418 327 560 327H8.00001C3.58173 327 0 323.418 0 319V257Z",
    fill: "url(#paint2_linear_32215_69)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 257H568L548 235H20L0 257Z",
    fill: "#2C9FDF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_32215_69)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 119,
    r: 8,
    fill: "#E5BF2B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 149,
    r: 8,
    fill: "#E5BF2B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 179,
    r: 8,
    fill: "#E5BF2B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 209,
    r: 8,
    fill: "#E5BF2B"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_32215_69)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 518,
    cy: 119,
    r: 8,
    fill: "#E5BF2B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 518,
    cy: 149,
    r: 8,
    fill: "#E5BF2B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 518,
    cy: 179,
    r: 8,
    fill: "#E5BF2B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 518,
    cy: 209,
    r: 8,
    fill: "#E5BF2B"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 221,
    width: 410,
    height: 5,
    fill: "#0F74AC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 102,
    width: 410,
    height: 5,
    fill: "#0F74AC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M161.5 240.5H66.5L54.5 251.5H150.5L161.5 240.5Z",
    fill: "#1089CC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M271.5 240.5H176.5L171.5 251.5H269.5L271.5 240.5Z",
    fill: "#1089CC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M298.5 240.5H393.5L398.5 251.5H300.5L298.5 240.5Z",
    fill: "#1089CC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M211 70.5V98",
    stroke: "#2294D3",
    strokeWidth: 8
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M361 70.5V98",
    stroke: "#2294D3",
    strokeWidth: 8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_32215_69",
    x: 180,
    y: 9,
    width: 212,
    height: 85,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_32215_69"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_32215_69",
    x: 26,
    y: 95,
    width: 48,
    height: 138,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.254902 0 0 0 0 0.721569 0 0 0 0 0.921569 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_32215_69"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_32215_69",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_32215_69",
    x: 494,
    y: 95,
    width: 48,
    height: 138,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.254902 0 0 0 0 0.721569 0 0 0 0 0.921569 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_32215_69"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_32215_69",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_32215_69",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(286 36) rotate(90) scale(36 125)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C3F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_32215_69",
    x1: 286,
    y1: 33,
    x2: 286,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EA7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01BBBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_32215_69",
    x1: 0.00000172879,
    y1: 301,
    x2: 568,
    y2: 302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CDBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58C3FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawBgLight);
export default __webpack_public_path__ + "static/media/drawBg_light.d738f854915d956654baf42ab91d2fd6.svg";
export { ForwardRef as ReactComponent };